<template>
  <div>
    <a-tabs>
      <a-tab-pane key="build" tab="业务监控建设情况">
        <service-build></service-build>
      </a-tab-pane>

      <a-tab-pane key="usage" tab="业务真实访问和资源使用情况">
        <service-usage></service-usage>
      </a-tab-pane>

      <a-tab-pane key="alert" tab="业务问题处理情况">
        <service-alert></service-alert>
      </a-tab-pane>

      <a-tab-pane key="ticket" tab="工单闭环情况">
        <service-ticket></service-ticket>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ServiceAlert from './modules/ServiceAlert.vue'
import ServiceBuild from './modules/ServiceBuild.vue'
import ServiceUsage from './modules/ServiceUsage.vue'
import ServiceTicket from './modules/ServiceTicket.vue'

export default {
  name: 'ServiceMonitor',
  components: {
    ServiceAlert,
    ServiceBuild,
    ServiceUsage,
    ServiceTicket
  }
}
</script>
